import React from 'react';
import {Box, Container, Text, Button, Link, Image} from "@chakra-ui/react";
import SvgPhone from "../../assets/svg/SvgPhone";
import aboutBanner from "../../assets/img/aboutBanner.webp"
import {WHATSAPP_LINK} from "../../helpers/adminData";
const AboutUs = () => {
    return (
        <Box name="about-us" w="full" mb={{base: "278px", lg: "154px"}}>
            <Container maxW="container.xl">
                <Box pos="relative" w="full" h="668px" bg="#EEEEEE" borderRadius="20px"
                     p={{base: "36px 10px", md: "69px 43px"}}>
                    <Box>
                        <Text fontFamily='Raleway' lineHeight={{base: "35px", md: "63px"}} fontWeight="700"
                              fontSize={{base: "30px", md: "54px"}} color="#111212">ОСОО
                            “Пром Сталь Кей Джи” - металлургическое предприятие.</Text>
                        <Text mt="30px" mb={{base: "50px", md: "52px"}} lineHeight={{base: "21px", md: "28px"}}
                              fontFamily='Raleway' fontWeight="400" fontSize={{base: "18px", md: "24px"}}
                              color="#000000">Мы работаем в сфере точного литья по <br/>газифицированным
                            моделям, <br/> изготавливаем отливки из специальных <br/> сталей с высоким сопротивлением
                            к <br/>износу при одновременном <br/> воздействии ударных нагрузок.</Text>
                      <Link href={WHATSAPP_LINK}>
                          <Button variant="none" zIndex="2" border="2px solid #E92F34" borderRadius="90px" w="220px" h="48px"
                                  fontWeight="700" fontFamily='Raleway' fontSize="16px" color="#E92F34"
                                  opacity="0.8" py="12px"  rightIcon={<Box pl="22px"><SvgPhone/></Box>}>Связаться</Button>
                      </Link>
                    </Box>
                    <Image w={{base: "411px", lg: "600px"}} h={{base: "411px", lg: "600px"}} pos="absolute"
                           bottom={{base: "-20%", lg: "0"}} right={{base: "-17px", lg: "0"}} zIndex="1" src={aboutBanner} alt=""/>
                </Box>
            </Container>
        </Box>
    );
};

export default AboutUs;
